var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFosInactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 24C9.62662 24 7.30651 23.2962 5.33312 21.9777C3.35973 20.6591 1.8217 18.7849 0.913445 16.5922C0.00519377 14.3995 -0.232439 11.9867 0.230584 9.65893C0.693607 7.33116 1.83647 5.19293 3.5147 3.5147C5.19293 1.83647 7.33116 0.693607 9.65893 0.230584C11.9867 -0.232439 14.3995 0.00519377 16.5922 0.913445C18.7849 1.8217 20.659 3.35973 21.9776 5.33312C23.2962 7.30651 24 9.62662 24 12H22C22 10.0222 21.4135 8.08876 20.3147 6.44427C19.2159 4.79978 17.6541 3.5181 15.8268 2.76122C13.9996 2.00435 11.9889 1.80628 10.0491 2.19213C8.10926 2.57798 6.32747 3.53042 4.92895 4.92895C3.53042 6.32747 2.57798 8.10926 2.19213 10.0491C1.80628 11.9889 2.00429 13.9996 2.76116 15.8268C3.51804 17.6541 4.79978 19.2159 6.44427 20.3147C8.08876 21.4135 10.0222 22 12 22V24Z",
    fill: "#4F4F4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9897 10C18.0943 10 18.9897 9.10457 18.9897 8C18.9897 6.89543 18.0943 6 16.9897 6C15.8852 6 14.9897 6.89543 14.9897 8C14.9897 9.10457 15.8852 10 16.9897 10Z",
    fill: "#4F4F4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H18V13H10V11H18C18.5304 11 19.0391 11.2107 19.4142 11.5858C19.7893 11.9609 20 12.4696 20 13V18Z",
    fill: "#4F4F4D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9897 24H16.9897V18H15.9897V24H13.9897V16H18.9897V24Z",
    fill: "#4F4F4D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9897 12H13.9897V18H18.9897V12Z",
    fill: "#4F4F4D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 24C7.84006 24 4.58008 18.73 4.58008 12C4.58008 5.27 7.84006 0 12.0001 0V2C9.06006 2 6.58008 6.58 6.58008 12C6.58008 17.42 9.06006 22 12.0001 22V24Z",
    fill: "#4F4F4D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9897 14H10.9897V24H12.9897V14Z",
    fill: "#4F4F4D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9897 1H10.9897V10H12.9897V1Z",
    fill: "#4F4F4D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9897 7H1.98975V9H11.9897V7Z",
    fill: "#4F4F4D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9897 15H1.98975V17H11.9897V15Z",
    fill: "#4F4F4D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFosInactive);
export default __webpack_public_path__ + "static/media/fos-inactive.7cf962edc56800179ba37054b65a52f5.svg";
export { ForwardRef as ReactComponent };